import { Link } from "react-router-dom";
import { FadeIn } from "./Reveal";

const CTASection = ({
  title = "You don't have to figure this out alone.",
  copy = "Schedule a free 20-minute consultation to see whether we're a good fit.",
}) => (
  <section className="bg-forest-900 relative overflow-hidden" data-testid="cta-section">
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold-500/10 blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28 text-center relative">
      <FadeIn>
        <p className="eyebrow mb-6">Take the First Step</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-cream-50 tracking-tight leading-[1.15] max-w-3xl mx-auto">
          {title}
        </h2>
        <p className="mt-5 text-base sm:text-lg text-cream-50/65 max-w-xl mx-auto leading-relaxed">{copy}</p>
        <Link
          to="/contact"
          data-testid="cta-schedule-button"
          className="inline-flex items-center mt-9 rounded-full bg-cream-50 text-forest-900 font-semibold text-sm tracking-wide px-8 py-4 transition-all duration-300 hover:bg-white hover:shadow-[0_12px_36px_rgba(0,0,0,0.25)]"
        >
          Schedule a Consultation
        </Link>
      </FadeIn>
    </div>
  </section>
);

export default CTASection;
